
import { defineComponent } from 'vue';
import TheLanguageSwitch from '@/components/organisms/utils/TheLanguageSwitch.vue';
import { useI18n } from '@/plugins/i18n';

export default defineComponent({
  name: 'TheHeader',
  components: { TheLanguageSwitch },
  setup() {
    const i18n = useI18n();
    const locale = i18n.locale;

    const headerNav = {
      ja: {
        access: 'アクセス方法',
        program: '企画紹介',
        schedule: 'スケジュール',
        faqContact: 'FAQ・問い合わせ',
        instances: 'インスタンス一覧',
        submissions: 'アバター＆ポスター募集',
      },
      en: {
        access: 'How to Access',
        program: 'Event Introductions',
        schedule: 'Schedule',
        faqContact: 'FAQ & Contact',
        instances: 'Instance List',
        submissions: 'Avatar & Poster Submissions',
      },
    };

    return {
      headerNav,
      locale,
    };
  },
});
